import type { FecThirdPartyMapping } from '../types/fecThirdPartyMapping'

/** The same account number in the same role from several files is one third party. */
export const dedupeFecThirdPartyMappings = (mappings: FecThirdPartyMapping[]): FecThirdPartyMapping[] => {
  const seenKeys = new Set<string>()

  return mappings.filter((mapping) => {
    const key = `${mapping.role}:${mapping.accountNo}`

    if (seenKeys.has(key)) {
      return false
    }

    seenKeys.add(key)
    return true
  })
}
